import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=9798f91a"
import script from "./Board.vue?vue&type=script&lang=ts"
export * from "./Board.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports